import { Field } from './facilities';
import { Player } from './player';
import { CustomUser } from './user';

export class Cancellation {
    canceller: CustomUser;
    reason: string;
    date_time: Date;
}

export class Reserva {
    id: number;
    facility: number;
    planner: number;
    name: string;
    field: Field;
    status: string;
    start_time: Date;
    end_time: Date;
    field_capacity: number;
    get_cant_player_display: string;
    phone: string;
    matches: number[];
    cancellation: Cancellation;
    tournament: number;
    match_tournament: number;
    reservation_type?: number;
    description?: string;
    reservation_group?: number;
    payway_payment?:number;
    payment_variable?:any;
    deposit_paid?: boolean;
}

export class ReservaRecurrente {
    id: number;
    facility: number;
    planner: number;
    name: string;
    field: Field;
    status: string;
    start_time: Date;
    end_time: Date;
    field_capacity: number;
    get_cant_player_display: string;
    phone: string;
    matches: number[];
    cancellation: Cancellation;
    tournament: number;
    match_tournament: number;
    end_date: any;
    selected_weekdays: number[];
    description?: string;
    reservation_group?: number;
}

export interface iReserva {
    facility: number;
    planner: number;
    name: string;
    phone: string;
    start_time: string;
    end_time: string;
    field_capacity: number;
    reservation_type?: number;
    description?: string;
    payment_variable?: any;
    deposit_paid?: boolean;
    payway_payment?: any;
}

export interface iReservaRecurrente {
    facility: number;
    planner: number;
    name: string;
    phone: string;
    start_time: string;
    end_time: string;
    field_capacity: number;
    end_date: string;
    selected_weekdays: string;
    reservation_type?: number;
    description?: string;
    reservation_group?: number;
}

export class Bucket {
    id: string;
    day: Date;
    h_desde: Date;
    h_hasta: Date;
    status: number;
    confirmados: number;
    planner: string;
    id_reserva: number;
}

export interface ReservaData {
    reserva: Reserva;
    day: Date;
    updateReserva: boolean;
}

export interface ReservaRecurrenteData {
    reserva: ReservaRecurrente;
    day: Date;
    updateReserva?: boolean;
}

export interface Guest {
    reservation: number;
    player: Player;
    status_id: number;
    status: string;
    after_match_id: number;
    after_match: string;
}
